import React from 'react';

function About() {
    return (
        <div className="container">
            
            <div id="contentsection1">
                <div className="desc">
                    <h2>About Me</h2>
                    I'm compscichris, and I am a current MS student at CSU Chico, studying Computer Science. I graduated with a BS in Computer Science at the 
                    University of Arizona, and am currently working part time as a Sales and Tech support staff. I am currently looking for employment in the 
                    industry, with a full-stack, database, and Machine Learning specialization, or specialization in computer architecture and embedded systems. 
                    I enjoy learning everything and anything about computer hardware and software. My hobbies include developing web applications, writing 
                    scripts and programs to help me calculate or keep track of inventorying, scheduling, and bookkeeping. I like building, upgrading, repairing 
                    any computer system, like desktop PCS, SBCs, and even mobile devices like smartphones and laptops. Currently, I am focused on building my 
                    own backend systems to host my own website and applications, as well as integrating it into the cloud for more availability and security.
                    <br/>
                    Besides the career tagential hobbies I have right now, I also enjoy watching basketball, movies, TV shows, exercising, and playing video
                    games in free time.
                </div>
                <div className="desc">
                    CS languages with strongest experience
                    <ul id="descList">
                        <li>Objected Oriented Programming in Java, C++, Python</li>
                        <li>Database programming in SQL and relational algebra</li>
                        <li>Procedural languages in C</li>
                        <li>Web development languages like HTML, CSS, JavaScript, and JSON</li>
                    </ul>
                    CS languages that I have briefly seen
                    <ul id="descList">
                        <li>Swift</li>
                        <li>.NET Visual Basic</li>
                    </ul>
                    Other CS and math skills
                    <ul id="descList">
                        <li>Machine Learning/Neural Networks</li>
                        <li>Algorithms</li>
                        <li>Operating Systems</li>
                        <li>AWS</li>
                        <li>Networking</li>
                    </ul>
                </div>
            </div>
            <div className="jumbotron margin">
                <a href="https://www.linkedin.com/in/christopher-chen-24214419a/" target="_blank">
                    <h5>LinkedIn Profile</h5>
                </a>
                <a href="https://github.com/compscichris" target="_blank">
                    <h5>GitHub</h5>
                </a>
            </div>
        </div>
    );
}

export default About;

